export default "__VITE_ASSET__BJCVuUR9__"